<script setup lang="ts">
import type { DashboardFooterSummary } from "../../features/dashboard/dashboard.types.ts";

defineProps<{
  summary: DashboardFooterSummary;
}>();
</script>

<template>
  <section
    class="dashboard-card grid gap-4 rounded-[1.5rem] px-5 py-5 xl:grid-cols-[1.2fr_1.5fr_1.3fr]"
  >
    <div class="dashboard-card--inner rounded-2xl px-4 py-4">
      <p
        class="dashboard-text-muted text-xs font-semibold tracking-[0.18em] uppercase"
      >
        Algorithm Confidence Score
      </p>
      <p
        class="dashboard-text-positive mt-4 text-[2.5rem] leading-none font-semibold"
      >
        {{ summary.confidenceScore }}
      </p>
      <p class="dashboard-text-secondary mt-3 text-sm">
        {{ summary.confidenceLabel }}
      </p>
    </div>

    <div class="dashboard-card--inner rounded-2xl px-4 py-4">
      <p
        class="dashboard-text-muted text-xs font-semibold tracking-[0.18em] uppercase"
      >
        {{ summary.runStatus }}
      </p>
      <p class="dashboard-text-primary mt-4 text-lg font-semibold">
        {{ summary.runCompletedAt }}
      </p>
      <p class="dashboard-text-secondary mt-2 text-sm">
        {{ summary.runDuration }}
      </p>
      <RouterLink
        :to="{ name: 'results' }"
        class="dashboard-text-link mt-4 inline-flex items-center gap-2 text-sm font-semibold no-underline"
      >
        View run history
        <span aria-hidden="true">›</span>
      </RouterLink>
    </div>

    <div class="dashboard-card--inner rounded-2xl px-4 py-4">
      <p class="dashboard-text-secondary text-sm">
        For full transparency and auditability
      </p>
      <RouterLink
        :to="{ name: 'dashboard-algorithm-trace-log' }"
        class="dashboard-link-button mt-4 inline-flex w-full items-center justify-center gap-3 rounded-2xl px-4 py-3 text-base font-semibold no-underline"
      >
        {{ summary.traceLogLabel }}
        <span aria-hidden="true">›</span>
      </RouterLink>
    </div>
  </section>
</template>
